var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tableBody",staticClass:"table-body",style:(_vm.tableBodyWidth)},[_c('div',{ref:"table",staticClass:"table"},[_c('div',{staticClass:"tbody"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }